/*------------------------------------------
      Testimonial Section Script 
------------------------------------------*/ 

$(document).ready(function() {
  $slideshow = $('.carousel-main .slides').slick({
   lazyLoad: 'progressive',
    autoplay: true,
	autoplaySpeed:5000,
	arrows: false,
	dots: false,
	speed: 800,
	infinite: true,
	swipe: true,
  asNavFor: '.carousel-slides-slide-1 .slides, .carousel-slides-slide-2 .slides'
});
  
$('.carousel-slides-slide-1 .slides').slick({
 lazyLoad: 'progressive',
   autoplay: true,
	autoplaySpeed:5000,
	arrows: false,
	centerPadding: '0px',
	infinite: true,
	centerMode: true,
	speed: 800,
	swipe: true,
	slidesToShow: 1,
    focusOnSelect: true,
   asNavFor: '.carousel-slides-slide-2 .slides, .carousel-main .slides'
   
});

$('.carousel-slides-slide-2 .slides').slick({
    lazyLoad: 'progressive',
    autoplay: true,
	autoplaySpeed:5000,
	arrows: true,
	centerPadding: '0px',
	infinite: true,
	centerMode: true,
	speed: 800,
	swipe: true,
	slidesToShow: 1,
    focusOnSelect: true,
    asNavFor: '.carousel-slides-slide-1 .slides, .carousel-main .slides',
    appendArrows:$('.multi-carousel-slides__controls')
});

/* icon bar */ 
$('.carousel-icon__slider').slick({
   arrows: true,
	centerPadding: '0px',
    autoplay: true,
	autoplaySpeed:5000,
	infinite: true,
	centerMode: true,
	speed: 800,
	swipe: true,
	slidesToShow: 3,
    focusOnSelect: true,
    responsive: [
          {
              breakpoint: 891,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
              }
          }
      ]
});
  
$('.carousel-main .slides').on('afterChange', function(event, slick, currentSlide){ 
//console.log(currentSlide + "show current slide");
  $('.carousel__AnimatedText').hide();
  //$('.carousel__AnimatedText').removeClass('fade-upText');
  $('.carousel__AnimatedText[data-id=' + (currentSlide) + ']').show();
  //$('.carousel__AnimatedText[data-id=' + (currentSlide) + ']').addClass('fade-upText');
});
  
// $('.carousel-slides-slide-1').on('click', function() {
//      var targetAction = $(this).attr('data-action');
//      console.log('target' + targetAction);
//       let slider = $('.carousel-main .slides');
//   	if(targetAction === "Previous") {
//   		slider.slick('slickNext');
//   	} else if(targetAction === "Next") {
//   		slider.slick('slickPrev');
//   	}
// });
  
// $( ".carousel-slides-slide-1 .slides" ).each(function(index) {
//     $(this).on("click", function(){
//        var targetAction = $(this).attr('data-action');
//     	if(targetAction == "Previous") {
//     		$slideshow.slick('slickNext');
//     	} else if(targetAction == "Next") {
//     		$(".multi-carousel-slides__controls").find('.slick-next').trigger("click");
//     	}
//     });
// });

   $('.carousel-slides-slide-1 .slides').click(function() {
    $slideshow.slick('slickNext');
  });

  

});

/*
  Image comparison script
*/ 
$(document).ready(function() {

  $("#SliderImgFilter").on("input change", (e)=>{
    const sliderPos = e.target.value;
//console.log(sliderPos);
    // Update the width of the foreground image
    $('.img-comparison-img-right').css('width', `${sliderPos}%`);
    // Update the position of the slider button
    $('.slider-button').css('left', `calc(${sliderPos}% - 26px)`);

    $('.img-comparison-controls').removeClass('transition-left');
      $('.img-comparison-img').removeClass('transition');

       $('.img-comparison-before').css({"visibility": ""});
  });

    $('.img-comparison-label').on('click', function() {
        var target = $(this).attr('data-action');
       $('.img-comparison-controls').addClass('transition-left');
      $('.img-comparison-img').addClass('transition');
      
      if(target == 'after'){
        //alert(target);
        $('.img-comparison-img-right').css('width', '99%');
        //$('#slider').val('83');
        $('.img-comparison-controls').css('left', `calc(99% - 26px)`);
      }else if(target == 'before'){
        //alert(target);
          //$('#slider').val('20');
          $('.img-comparison-img-right').css('width', '5%');
          $('.img-comparison-controls').css('left', `calc(5% - 26px)`);
        }
    });  
});


// Scrolling Banner
  document.addEventListener( 'DOMContentLoaded', function () {
    new Splide('#splide', {
      type: 'loop',
      perPage: 1,
      autoWidth:true,
      arrows: false,
      focus: 'center',
      autoplay: false,
      // interval: 8000,
      // flickMaxPages: 3,
      // updateOnMove: true,
      pagination: false,
      
      // padding: '10%',
      // throttle: 300,
      autoScroll: {
        speed: 0.5,
      } 
    }).mount(window.splide.Extensions);
  }); 


/*
  Get Sync Inventory Product Functionality
*/ 
$(document).ready(function() {

  // Update qnty of main qnty selector
  function UpdateQntyCust(selectorQuantity, VariantQnty) {
    //alert(selectorQuantity+ VariantQnty);
    //var selectorQuantity = parseFloat($('#CustomQuantity').val());
    //var GetVariantQnty = parseFloat($(this).attr('data-qnty'));
    var tottal = selectorQuantity * VariantQnty; 
    $('.velaQty').find("input[name='quantity']").val(selectorQuantity * VariantQnty); 
     //console.log('custom:'+selectorQuantity + 'update'+ VariantQnty + 'tottal:'+tottal);
  }

  // For custom swatch options
  if($('#CustomQuantity').length){
      $(".custom-swatch :radio").change(function() {       
        if($('#custom-sync-item'))
        var t = $(this).closest(".custom-swatch").attr("data-option-index");
        var n = $(this).val();
        var title = $(this).attr('data-title');
        var price = $(this).attr('data-price'); 
        var Get_price_without_currency = $(this).attr('data-price-sel');
            
        // Uncheck other variant element
        $(".custom-swatch").find("input[type='radio']").prop('checked',false);
        $(this).closest('.custom-swatch').siblings('.swatch').find("input[type='radio']").prop('checked',false);
        // check this element
        $(this).prop('checked', true);
        $(this).closest("form").find("#productSelect").val(title).trigger("change");
        $(this).closest("form").find(".single-option-selector").eq(t).val(title).trigger("change");
        var selectorQnty = parseFloat($('#CustomQuantity').val());
        var GetVarQnty = parseFloat($(this).attr('data-qnty'));
        //var total = selectorQuantity * GetVariantQnty; 
        //$('.velaQty').find("input[name='quantity']").val(selectorQuantity * GetVariantQnty); 
    
         // update selected item details
        $('.custom-swatch-container').find('.js-swatch-display').text(title);
        $('.proPrice').find('#ProductPrice').text(price);
        $('#custom-sync-item').val(n);
        $('#custom-sync-item').attr('data-selected-qnty', GetVarQnty);
        $('#sync-quantity').val(GetVarQnty);
        $('#product-variant').val(title);
        var CurrentSku =  $('#product-variant-sku').attr('data-sku');
        $('#product-variant-sku').val(GetVarQnty+' x '+CurrentSku);

        //  EyeMask Wholesale Product
        if($('#product-EyeMask-sku').length){
          var UpdatedTitle =  $(this).attr('data-title').replace('Pack','');
          $('#product-EyeMask-sku').val(UpdatedTitle+'(3-Packs)');
          $('#product-EyeMask-sku').attr('data-sku', UpdatedTitle+'(3-Packs)' );
        }
        
        
    
       // sync with subscription
        if($('.rc-container-wrapper').length){
        var select_var = $(this).parent('.swatch-element').attr('data-synced-id');
         $('#custom-sync-item').val(select_var);
          $('#customVariantSel').val(select_var);
        }
        
        
        //console.log(price +'show price');
        // Update pack details 
        if($('#product-pack-details'.length)){
          var PackDetails = 'properties'+ '['+$('#sync-variant').val() + ' x ' + GetVarQnty + ' = '+ title+ ']';
          $('#product-pack-details').attr('name', PackDetails);
        }
        // Update main qnty field value
        UpdateQntyCust(selectorQnty, GetVarQnty);
        
    });
  }
  // For default swatch options
   if($('#customSwatch-js').length){
   $(".swatch :radio").change(function() {      
        //START : sync-inverntory : check for custom selector 
           var VariTitle = $(this).val();
            $(this).closest('.swatch').siblings('.custom-swatch').find("input[type='radio']").prop('checked',false);
           var GetVariQnty = parseFloat($(this).attr('data-qnty'));
          var seleQnty = parseFloat($('#CustomQuantity').val());
         $('#custom-sync-item').attr('data-selected-qnty', GetVariQnty);
         $('#sync-quantity').val(GetVariQnty);

      // Update pack details 
     if($('#product-pack-details'.length)){
        var PackDetails = 'properties'+ '['+$('#sync-variant').val() + ' x ' + GetVariQnty + ' = '+ VariTitle+ ']';
        $('#product-pack-details').attr('name', PackDetails);
     }
         UpdateQntyCust(seleQnty, GetVariQnty);
       //END : sync-inverntory : check for custom selector

     
    });
   }

    // Update main quantity field on custom qnty change
  if($('#custom-sync-item').length){
     $(document).on("click",".velaQtyButton",function() {
       var custQnty =  $(this).parent('.velaQty').find('#CustomQuantity').val();
       var updatedQnty = $('#custom-sync-item').attr('data-selected-qnty');

       
       // check for cart template 
      if($('.template-cart').length){
          var Quantity = parseFloat( $(this).parent('.velaQty').siblings('.MainQntySel').find(".velaQty").find("input[name='updates[]']").val());
          //var variQnty = parseFloat($('#custom-sync-item').attr('data-selected-qnty'));
          var variQnty = parseFloat($(this).closest('.cartGroup').parent('.productInfo').find('#custom-sync-item').attr('data-selected-qnty'));
         if($(this).hasClass('velaQtyPlus')){
             var tot = Quantity + variQnty; 
               $(this).parent('.velaQty').siblings('.MainQntySel').find('.velaQty').find("input[name='updates[]']").val(Quantity + variQnty); 
             console.log('custom:'+Quantity + 'update'+ variQnty + 'tottal:'+tot);
          }
          else{
             var tot = Quantity - variQnty; 
              $(this).parent('.velaQty').siblings('.MainQntySel').find('.velaQty').find("input[name='updates[]']").val(Quantity - variQnty); 
             console.log('custom:'+Quantity + 'update'+ variQnty + 'tottal:'+tot);
          }

        
      }else{
        UpdateQntyCust(custQnty, updatedQnty);
      }
    });
  }
      
});

$(window).load(function() {
  if($('.template-cart').length){
    $( ".productInfo" ).each(function( index ) {
      if($(this).find('#custom-sync-item').length){
       var Get_custQnty =  parseFloat($(this).find('.MainQntySel').find(".velaQty").find("input[name='updates[]']").val());
       var Get_updatedQnty = parseFloat($(this).find('#custom-sync-item').attr('data-selected-qnty'));
       console.log(Get_custQnty / Get_updatedQnty + 'customval');
          $(this).find("input[name='custQuantity']").val(Get_custQnty / Get_updatedQnty);
         var se_defualt_min =$(this).find('#custom-sync-item').attr('data-selected-qnty');
//console.log(se_defualt_min);
          $(this).find('.sync-product-qnty').find("input[name='updates[]']").attr('min',se_defualt_min);
         $(this).find("input[name='custQuantity']").attr('min',se_defualt_min);
        //Hide default variant title
        $(this).find('.productVariant').hide();
      }
    });
  }else{
    if($('#CustomQuantity').length){
      var cust_Qnty =  $('#CustomQuantity').val();
         var updated_Qnty = $('#custom-sync-item').attr('data-selected-qnty');
      var tottal = cust_Qnty * updated_Qnty; 
      $('.velaQty').find("input[name='quantity']").val(cust_Qnty * updated_Qnty); 
    }
    // To hide first variant 
    if($('#product-hidden-variant').length){
      var variantTitle = $('#product-hidden-variant').attr('data-title');
     setTimeout(function() {
       $('.single-option-selector').val(variantTitle).change();
           $('.eye-mask-details').find('#product-variant').val(variantTitle);
      }, 800);
      // $(".swatch").trigger("change");
   }
  }

  
});

/*
  START : Dynamic product quantity update [Bundle functionality]
*/ 
$(window).load(function() {
  if($('.template-product').length){
    var defaultVal = $('.customSelector').find("input[name='quantity']").val();
    // set deafult min value of qnty
    $('.customSelector').find("input[name='quantity']").attr('min',defaultVal);
    $('.customSelector').find('.velaQtyMinus').attr("disabled", "disabled");
     console.log(defaultVal+'min ');
  }

   if($('.template-cart').length){
    $(".productInfo" ).each(function( index ) {
       if($(this).find('#wholesale-qnty').length){
        var CartVariantQnty = $(this).find('#wholesale-qnty').attr('data-selected-qnty');
        var CartProQnty  = $(this).find('.customSelector').find('input[name="updates[]"]').val();
         $(this).find('.customSelector').find('input[name="updates[]"]').attr('min',CartVariantQnty);

         if(CartProQnty <= CartVariantQnty){
           $(this).find('.customSelector').find('.velaQtyMinus').attr("disabled", "disabled");
         }else{
            $(this).find('.customSelector').find('.velaQtyMinus').removeAttr("disabled");
         }
         
       }
    });
       
   }
                             
  
 
});

$(document).ready(function() {

  if($(".update_cust_product_temp").length){
        $( window ).on("load", function() {
    
          setTimeout(function() {
            var get_load_discount_price = $("#ProductPrice__cust_discount").text();
            var get_load_normal_price = $("#ProductPrice__cust_normal").text();
            var get_load_custom_qty = $("#ProductPrice__cust_normal").attr("data-current-custom-qty");
            $("form.formAddToCart").find("#Quantity").val(get_load_custom_qty);
            
            $(".rc-template__button-group .rc-radio .rc-option__price.rc_widget__price--subsave").attr("data-subsave-price",get_load_discount_price);
            $(".rc-template__button-group .rc-radio .rc-option__price.rc_widget__price--onetime").attr("data-onetime-price",get_load_normal_price);        
          }, 2000); 
          
         
        });
      
        $('body').on('change', '.rc-template__button-group .rc-radio .rc-radio__input', function() {
            var get_rc_selected_value = $(this).val();
            //alert("You gg."+get_rc_selected_value);
            if(get_rc_selected_value == "onetime"){
                $("form.formAddToCart").addClass("rc_selected_onetime");
                $("form.formAddToCart").removeClass("rc_selected_subsave");
            }else{
                $("form.formAddToCart").addClass("rc_selected_subsave");
                $("form.formAddToCart").removeClass("rc_selected_onetime");
            }
        });    
  }
 if($(".eye-mask__custPrice").length){
   $( window ).on("load", function() {
    
          setTimeout(function() {
            var get_load_discount_price = $("#Price__cust_discount").text();
            var get_load_normal_price = $("#Price__cust_normal").text();
            var get_load_custom_qty = $("#Price__cust_normal").attr("data-current-custom-qty");
            $("form.formAddToCart").find("#Quantity").val(get_load_custom_qty);
            
            $(".rc-template__button-group .rc-radio .rc-option__price.rc_widget__price--subsave").attr("data-subsave-price",get_load_discount_price);
            $(".rc-template__button-group .rc-radio .rc-option__price.rc_widget__price--onetime").attr("data-onetime-price",get_load_normal_price);        
          }, 2000); 
        });

       $('body').on('change', '.rc-template__button-group .rc-radio .rc-radio__input', function() {
            var get_rc_selected_value = $(this).val();
            //alert("You gg."+get_rc_selected_value);
            if(get_rc_selected_value == "onetime"){
                $("form.formAddToCart").addClass("rc_selected_onetime");
                $("form.formAddToCart").removeClass("rc_selected_subsave");
            }else{
                $("form.formAddToCart").addClass("rc_selected_subsave");
                $("form.formAddToCart").removeClass("rc_selected_onetime");
            }
        }); 

    $('body').on('change', '.swatch :radio', function() {
        var get_normal_price =  $(this).closest(".swatch-element").find("label").attr("data-vnormal-price");
        var get_discount_price =  $(this).closest(".swatch-element").find("label").attr("data-vdiscount-price");
        var get_discount_qty =  $(this).attr("data-qnty");
      
        $("#Price__cust_normal").html(get_normal_price);
        $("#Price__cust_discount").html(get_discount_price);
        //alert("You ."+get_normal_price+" == "+get_discount_price);
        $(this).closest("form.formAddToCart").find("#Quantity").val(get_discount_qty);
      
        setTimeout(function() {
          $(".rc-template__button-group .rc-radio .rc-option__price.rc_widget__price--subsave").attr("data-subsave-price",get_discount_price);
          $(".rc-template__button-group .rc-radio .rc-option__price.rc_widget__price--onetime").attr("data-onetime-price",get_normal_price);
       }, 200);
      
    });
   
 }
  

 if($("#25pc_Retail_Packaging").length){
    $('body').on('change', '.swatch :radio', function() {
        var get_normal_price =  $(this).closest(".swatch-element").find("label").attr("data-vnormal-price");
        var get_discount_price =  $(this).closest(".swatch-element").find("label").attr("data-vdiscount-price");
        var get_discount_qty =  $(this).attr("data-qnty");
      
        $("#ProductPrice__cust_normal").html(get_normal_price);
        $("#ProductPrice__cust_discount").html(get_discount_price);
        //alert("You ."+get_normal_price+" == "+get_discount_price);
        $(this).closest("form.formAddToCart").find("#Quantity").val(get_discount_qty);
      
        setTimeout(function() {
          $(".rc-template__button-group .rc-radio .rc-option__price.rc_widget__price--subsave").attr("data-subsave-price",get_discount_price);
          $(".rc-template__button-group .rc-radio .rc-option__price.rc_widget__price--onetime").attr("data-onetime-price",get_normal_price);
       }, 200);
      
    });
 }
  
 if($('.customSelector').length){
   
   $(".swatch :radio").change(function() {
      //alert("jd");
     
      var Get_variantQnty = $(this).attr('data-qnty');
      $('.customSelector').find("input[name='quantity']").val(Get_variantQnty);
      $('.customSelector').find("input[name='quantity']").attr('min',Get_variantQnty);
      $('#wholesale-pack-info').attr('data-selected-qnty', Get_variantQnty);
      $('#wholesalepack-qnty').val(Get_variantQnty);

       // Update price according to pack.
     if($('#product-tagsf').length){
      
      var product_tag = $('#product-tags').val();
       if(product_tag == 'update_cust_price'){
         var SelectedVar = $(this).attr('data-var-id');
         var OnChangeVarPrice =  $('#productSelect option[value="'+SelectedVar+'"]').attr('data-price');
         var SelectedVarPrice =  $('#ProductPrice').text();
         var SelectedVarPrice1 = SelectedVarPrice.replace(/\D*/, "");
         var SelectedVarQnty = $('.customSelector').find("input[name='quantity']").val();
         
         var TotPrice = SelectedVarQnty * SelectedVarPrice1;
         var FinalPrice = TotPrice.toFixed(2); 
         $('#ProductPrice__cust').text(Shopify.formatMoney(FinalPrice)); 
          console.log(product_tag + 'has tag'+SelectedVarPrice1 +': ID :'+SelectedVar + 'qty : '+SelectedVarQnty );
  
         // On change calculate one-time purchase price.
         var TotPrice_OneTime = SelectedVarQnty * OnChangeVarPrice;
         var FinalPrice_OneTime = TotPrice_OneTime.toFixed(2); 
         // Update RC widget price
         if($('.rc-container-wrapper').length){
           $('.rc-container-wrapper').find('.rc-option__onetime').find('[data-price-onetime]').css({"opacity": "0"});
            setTimeout(function() {
                 $('.rc-container-wrapper').find('.rc-option__onetime').find('[data-price-onetime]').css({"opacity": "1"});
                 $('.rc-container-wrapper').find('.rc-option__onetime.rc-option--active').find('[data-price-onetime]').text(Shopify.formatMoney(FinalPrice));
                 $('.rc-container-wrapper').find('.rc-option__subsave.rc-option--active').find('[data-price-subsave]').text(Shopify.formatMoney(FinalPrice));

              // onchange update one-time purchase price.
                $('.rc-container-wrapper').find('.rc-option__onetime').find('[data-price-onetime]').text(Shopify.formatMoney(FinalPrice_OneTime));
              }, 200);
          
          }                 
       }
       
     }
      //console.log(Get_variantQnty+'qnty ');
   });


  // Update qnty selector on change
   $(document).on("click",".customSelector .velaQtyButton",function() {
     var GetPrevVal = parseInt($(this).closest('.customSelector').find("input[name='quantity']").val());
     var GetMinVal = $('.customSelector').find("input[name='quantity']").attr('min');
     
     var GetDefaultQnty =parseInt($('#wholesale-pack-info').attr('data-selected-qnty'));


      if($('.template-cart').length){
         var currentQnty = parseFloat( $(this).closest('.wholesale-pack-selector').find(".velaQty").find("input[name='updates[]']").val());
          //var variQnty = parseFloat($('#custom-sync-item').attr('data-selected-qnty'));
          var GetvariQnty = parseInt($(this).closest('.cartGroup').parent('.productInfo').find('#wholesale-qnty').attr('data-selected-qnty'));
        
        if($(this).hasClass('velaQtyPlus')){
             var TotQnty = parseInt(currentQnty + GetvariQnty); 
               $(this).closest('.wholesale-pack-selector').find(".velaQty").find("input[name='updates[]']").val(TotQnty - 1); 
           //console.log(currentQnty + 'tot' + GetvariQnty);
          }
          else{
                 var TotQnty = parseInt(currentQnty - GetvariQnty); 
               $(this).closest('.wholesale-pack-selector').find(".velaQty").find("input[name='updates[]']").val(TotQnty + 1); 
                //console.log(currentQnty + 'tot' + GetvariQnty);
          }
          // set for minimun qnty
            var GetCurVal = parseInt($(this).closest('.customSelector').find("input[name='updates[]']").val());
        //console.log(GetCurVal+'tot' + GetvariQnty);
           if(GetCurVal <= GetvariQnty){
              if($(this).hasClass('velaQtyMinus')){
                $(this).attr("disabled", "disabled");
              }
           }else{
             $(this).closest('.customSelector').find('.velaQtyMinus').removeAttr("disabled");
           }
        

      }else{
           // update qnty dynamically for variants
            if($(this).hasClass('velaQtyPlus')){
               var TotalQnty = parseInt(GetPrevVal + GetDefaultQnty);
               $('.customSelector').find("input[name='quantity']").val(TotalQnty - 1); 
            }else{
               var TotalQnty = parseInt(GetPrevVal - GetDefaultQnty);
               $('.customSelector').find("input[name='quantity']").val(TotalQnty + 1); 
            }
       
           // set for minimun qnty
            var GetCurrentVal = parseInt($(this).closest('.customSelector').find("input[name='quantity']").val());
           if(GetCurrentVal <= GetMinVal){
              if($(this).hasClass('velaQtyMinus')){
                $(this).attr("disabled", "disabled");
              }
           }else{
             $('.customSelector').find('.velaQtyMinus').removeAttr("disabled");
           }
      }
     
      //console.log(GetCurrentVal + 'current val' + GetMinVal+ 'min val' + TotalQnty +'total');
     
   });


 }

  
});

$(window).load(function() {
  if($('.customSelector').length){
    var defualt_min = $('#wholesale-pack-info').attr('data-selected-qnty');
    $('.customSelector').find("input[name='quantity']").val(defualt_min);
    $('.customSelector').find("input[name='quantity']").attr('min',defualt_min);

    // set variant availablity
    var swatchItem = $('.custom-swatch').find('.swatch-element').find('.swatchItem');
    //var qnty_tobe_deduced = swatchItem.attr('data-qnty');
    //var current_var_qnty  = swatchItem.attr('data-tot-qnty');
    swatchItem.each(function(i) {
      var qnty_tobe_deduced =  parseFloat($(this).attr('data-qnty'));
      var current_var_qnty  = parseFloat($(this).attr('data-tot-qnty')); 
       
      if(parseInt(qnty_tobe_deduced) > parseInt(current_var_qnty)){
        //console.log('deduce:'+qnty_tobe_deduced);
        //console.log('tot:'+current_var_qnty);
        $(this).prop('disabled','disabled');
      }
      
    });
    
  }

  // update price on load
  
   if($('#product-tagsf').length){
       setTimeout(function() {
     var DefaultVal_OneTime  = $('.rc-container-wrapper').find('.rc-option__onetime').find('[data-price-onetime]').text();
     var DefaultVal_Subsave  = $('.rc-container-wrapper').find('.rc-option__subsave').find('[data-price-subsave]').text();
       console.log(DefaultVal_Subsave +'show' +DefaultVal_OneTime );
         $('#OneTime_purchase').attr('data-val',DefaultVal_OneTime);
      }, 400);
      var product_tag = $('#product-tags').val();
       if(product_tag == 'update_cust_price'){
         var SelectedVar = $('#default-variant').val();
         //var SelectedVarPrice =  $('#productSelect option[value="'+SelectedVar+'"]').attr('data-price');
         var SelectedVarPrice =  $('#ProductPrice').text();
         var SelectedVarPrice1 = SelectedVarPrice.replace(/\D*/, "");
         var SelectedVarQnty = $('.customSelector').find("input[name='quantity']").val();
         var TotPrice_1 = SelectedVarQnty * SelectedVarPrice1;
         var FinalPrice_1 = TotPrice_1.toFixed(2); 
         $('#ProductPrice__cust').text(Shopify.formatMoney(FinalPrice_1)); 
          setTimeout(function() {
             if($('.rc-container-wrapper').length){
                   $('.rc-container-wrapper').find('.rc-option__onetime').find('[data-price-onetime]').css({"opacity": "1"});
                    $('.rc-container-wrapper').find('.rc-option__onetime').find('[data-price-onetime]').text(Shopify.formatMoney(FinalPrice_1));
               }
           }, 500);
       }
   }

  $(document).on("click",".rc_widget__optionf",function() {
         var SelectedVarPrice_3 =  $('#ProductPrice').text();
         var SelectedVarPrice1_3 = SelectedVarPrice_3.replace(/\D*/, "");
         var SelectedVarQnty_3 = $('.customSelector').find("input[name='quantity']").val();
         
         var TotPrice_3 = SelectedVarQnty_3 * SelectedVarPrice1_3;
         var FinalPrice_3 = TotPrice_3.toFixed(2); 
         $('#ProductPrice__cust').text(Shopify.formatMoney(FinalPrice_3)); 
        setTimeout(function() {
             if($('.rc-container-wrapper').length){
                    $('.rc-container-wrapper').find('.rc-option__onetime').find('[data-price-onetime]').text(Shopify.formatMoney(FinalPrice_3));
                   $('.rc-container-wrapper').find('.rc-option__subsave').find('[data-price-subsave]').text(Shopify.formatMoney(FinalPrice_3));
               }
           }, 200);
  });
 
});

// enable swatches on window load
$(document).ready(function() {
    if($('.swatch').length){
      setTimeout(function() {
        $('.swatch').find('.swatch-element').removeClass('loading__Swatch');
      }, 1000);   
    }
});

/*
  END : Dynamic product quantity update [Bundle functionality]
*/


/*
  START: Intense Hydration Eye Mask Bundle[Retailer]
*/ 
$(document).ready(function() {
  $(".custom-swatch :radio").change(function() {
    //  EyeMask Wholesale Product
    if($('#product-EyeMask-sku').length){
      var UpdatedTitle =  $(this).val().replace('Pack','');
      $('#product-EyeMask-sku').val(UpdatedTitle+'(3-Packs)');
      $('#product-EyeMask-sku').attr('data-sku', UpdatedTitle+'(3-Packs)' );
    }
  });
});
/*
  END: Intense Hydration Eye Mask Bundle[Retailer] 
*/ 


if($('.template-product').length){

}else{
// Custom Logo Scrolling
  document.addEventListener( 'DOMContentLoaded', function () {
    new Splide('#ScrollingLogos', {
      type: 'loop',
      perPage: 9,
      autoWidth:true,
      arrows: true,
      focus: 'center',
      autoplay: false,
      pagination: false,    
      autoScroll: {
        speed: 0.5,
      } 
    }).mount(window.splide.Extensions);
  });
}


// START: Professional Login Tab
$(document).ready(function() {  
  if($('.template-account').length){
    if($('.velaAccountLogin').length){
       $(document).on("click","#professional_login_link",function() {
          //alert('clci');
          $('html, body').animate({scrollTop: '0px'}, 300);
           var CurrentPath =  window.location.href;  
            console.log(CurrentPath+'current path 2');
            $('.velaFormAccount').find('.navFormAccount').find('.AccountTabNav').removeClass('active');
            $('.velaFormAccount').find('.tab-content').find('.tab-pane').removeClass('active');
        
              // Set professional to active
             $('.velaFormAccount').find('.navFormAccount').find('#ProfessionalLogin').addClass('active');
             $('.velaFormAccount').find('.tab-content').find('#frmAccountTabLogin').addClass('active');
         
        });
  $(document).on("click","#customer_register_link",function() {
          //alert('clci');
          $('html, body').animate({scrollTop: '0px'}, 300);
           var CurrentPath =  window.location.href;  
            console.log(CurrentPath+'current path 2');
            $('.velaFormAccount').find('.navFormAccount').find('.AccountTabNav').removeClass('active');
            $('.velaFormAccount').find('.tab-content').find('.tab-pane').removeClass('active');
        
              // Set professional to active
             $('.velaFormAccount').find('.navFormAccount').find('#Professionalregister').addClass('active');
             $('.velaFormAccount').find('.tab-content').find('#frmProfessionalTabRegister').addClass('active');
         
        });


      
     }
  }                                          
}); 
// END: Professional Login Tab